import { LogOut, Shield } from "lucide-react";
import MenuIconTooltip from "./MenuIconTooltip";
import { ACCOUNT_MENU_MODES } from "../utils/accountMenuPreference";
import { MENU_MODE_TOOLTIPS } from "../constants/menuTooltips";
import { useHoverMenuOpen } from "../hooks/useHoverMenuOpen";

const ICON_SIZE = 50;

/**
 * Entrée menu Déconnexion / Administration (compte admin uniquement).
 * Même pastille que Registre / Carnet : le choix d'icône est conservé.
 */
export default function AccountMenuSwitch({
  workspaceMode = ACCOUNT_MENU_MODES.LOGOUT,
  sectionActive = false,
  onEnterSection = () => {},
  onWorkspaceChange = () => {},
  onLogout = () => {},
}) {
  const { open, setOpen, wrapRef, onMouseEnter, onMouseLeave } = useHoverMenuOpen(true);
  const isAdmin = workspaceMode === ACCOUNT_MENU_MODES.CPANEL;
  const ActiveIcon = isAdmin ? Shield : LogOut;
  const InactiveIcon = isAdmin ? LogOut : Shield;
  const inactiveWorkspace = isAdmin
    ? ACCOUNT_MENU_MODES.LOGOUT
    : ACCOUNT_MENU_MODES.CPANEL;
  const activeTooltip = isAdmin
    ? MENU_MODE_TOOLTIPS.cpanel
    : MENU_MODE_TOOLTIPS.logout;
  const inactiveTooltip = isAdmin
    ? MENU_MODE_TOOLTIPS.logout
    : MENU_MODE_TOOLTIPS.cpanel;

  const handleActiveClick = () => {
    if (isAdmin) {
      if (!sectionActive) onEnterSection();
      return;
    }
    onLogout();
  };

  const handleInactiveClick = () => {
    onWorkspaceChange(inactiveWorkspace);
    setOpen(false);
  };

  return (
    <div
      ref={wrapRef}
      className={`register-workspace-menu-item${open ? " register-workspace-menu-item--open" : ""}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {open ? (
        <div
          className="register-workspace-switch"
          role="group"
          aria-label="Choisir déconnexion ou administration"
        >
          <MenuIconTooltip
            tooltip={activeTooltip}
            placement="below"
            portal
            arrow={false}
            className="register-workspace-switch__tip"
          >
            <button
              type="button"
              className="register-workspace-switch__option register-workspace-switch__option--active"
              onClick={handleActiveClick}
              aria-label={activeTooltip}
              aria-current="true"
            >
              <ActiveIcon size={ICON_SIZE} color="#39210d" strokeWidth={1} />
            </button>
          </MenuIconTooltip>
          <MenuIconTooltip
            tooltip={inactiveTooltip}
            placement="below"
            portal
            arrow={false}
            className="register-workspace-switch__tip"
          >
            <button
              type="button"
              className="register-workspace-switch__option"
              onClick={handleInactiveClick}
              aria-label={inactiveTooltip}
            >
              <InactiveIcon size={ICON_SIZE} color="#39210d" strokeWidth={1} />
            </button>
          </MenuIconTooltip>
        </div>
      ) : (
        <MenuIconTooltip
          tooltip={activeTooltip}
          placement="below"
          className={sectionActive ? "icon active" : "icon"}
        >
          <ActiveIcon
            size={ICON_SIZE}
            color="#39210d"
            strokeWidth={1}
            onClick={handleActiveClick}
            aria-label={activeTooltip}
          />
        </MenuIconTooltip>
      )}
    </div>
  );
}
